














































































































import _ from 'lodash'
import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import EventBus from '@/plugins/EventBus'
import moment from 'moment'
import BackofficeContratosStore from '../../contratos/Store/BackofficeContratosStore'

@Component
export default class ModalNovoContrato extends Vue {
  $refs: {
    formNovoContrato: any,
    menu: any,
    descricaoField: any,
    tipoField: any,
  }

  contratoRules: any = {
    valid: true,
    fontePagadora: [(v: any) => !!v || 'A fonte pagadora é obrigatória.'],
    prestador: [(v: any) => !!v || 'O prestador é obrigatório.'],
    inicioVigencia: [(v: any) => !!v || 'A data de início da vigência é obrigatória.'],
  }

  valorGarantiaMinimaRule = (value: any) => !!value || 'O valor é obrigatório.'
  menuInicioVigencia: boolean = false
  menuFimVigencia: boolean = false
  searchPrestador: string = ''
  loadingPrs: boolean = false
  ignoreNextPrestadorSearch: boolean = false

  debounce = _.debounce(async (search: string) => {
    await this.backofficeContratoStore.getAllPrestadoresRecebimento({ limite: 20, filtro: search })
    this.loadingPrs = false
  }, 700)

  get backofficeContratoStore() { return getModule(BackofficeContratosStore, this.$store) }

  loadAddRegraCalculo: boolean = false
  get loadingAddRegraCalculo() { return this.loadAddRegraCalculo }
  set loadingAddRegraCalculo(value: boolean) { this.loadAddRegraCalculo = value }

  get showModal() { return this.backofficeContratoStore.modal.novoContrato }
  set showModal(value: boolean) { this.backofficeContratoStore.setShowModalNovoContrato(value) }

  get fontesPagadoras() { return this.backofficeContratoStore.fontesPagadoras }
  get prestadores() { return this.backofficeContratoStore.prestadoresRecebimento }

  get getMenuInicioVigencia() { return this.menuInicioVigencia }
  set getMenuInicioVigencia(value: boolean) { this.menuInicioVigencia = value }

  get selectedFontePagadora() { return this.backofficeContratoStore.selectedFontePagadora }
  set selectedFontePagadora(value: any) { this.backofficeContratoStore.setSelectedFontePagadora(value) }

  get selectedPrestador() { return this.backofficeContratoStore.selectedPrestador }
  set selectedPrestador(value: any) { this.backofficeContratoStore.setSelectedPrestador(value) }

  get selectedInicioVigencia() { return this.backofficeContratoStore.selectedInicioVigencia }
  set selectedInicioVigencia(value: any) { this.backofficeContratoStore.setSelectedInicioVigencia(value) }

  async addNovoContrato() {
    this.loadingAddRegraCalculo = true
    if (!this.$refs.formNovoContrato.validate()) {
      this.loadingAddRegraCalculo = false
      return
    }
    const request = await this.backofficeContratoStore.addNovoContrato()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message ? request.message : 'Não foi possível adicionar o novo contrato'} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingAddRegraCalculo = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Contrato incluído com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingAddRegraCalculo = false
    this.showModal = false
  }

  async fetchPrestadores() {
    this.loadingPrs = true
    await this.debounce(this.searchPrestador)
    this.loadingPrs = false
  }

  onChangePrestador() {
    this.ignoreNextPrestadorSearch = true
  }

  @Watch('searchPrestador')
  onSearchPrestadorChanged(val: string) {
    if (this.ignoreNextPrestadorSearch) {
      this.ignoreNextPrestadorSearch = false
      return
    }

    if (!val || val.trim() === '') {
      this.backofficeContratoStore.clearPrestadores()
      return
    }

    if (val.length < 3) {
      return
    }

    this.loadingPrs = true
    if (this.debounce) this.debounce(val)
  }

  @Watch('prestadores')
  onPrestadoresChanged(val: any[]) {
    if (val) {
      this.loadingPrs = false
    }
  }

  @Watch('showModal')
  async onChangeShowModalAddRegraCalculoOperadora(value: boolean) {
    if (value) {
      this.searchPrestador = ''
    } else {
      this.backofficeContratoStore.clearPrestadores()
      this.backofficeContratoStore.clearNovoContrato()
      this.$refs.formNovoContrato.resetValidation()
    }
  }

  async mounted() {
    this.loadingPrs = true
    try {
      await this.backofficeContratoStore.getAllPrestadoresRecebimento({ limite: 20 })
    } finally {
      this.loadingPrs = false
    }
    // await this.backofficeContratoStore.getFontesPagadoras()
    // await this.backofficeContratoStore.getPrestadoresRepasse()
    // await this.backofficeContratoStore.getProfissionais()
    // await this.backofficeContratoStore.getCentroDeCusto()
  }
}
